import { Tab, Tabs, useTheme } from "@mui/material";

export default function MenuTabs({
    tabs,
    selectedIndex,
    handleTabChange,
}: {
    tabs: {
        label: string,
        index: number,
    }[],
    selectedIndex: number,
    handleTabChange: (event: React.SyntheticEvent, index: number) => void,
}) {    
    const theme = useTheme();

    return (
        <div className="w-full overflow-x-auto border-b border-outline">
            <Tabs 
                value={selectedIndex} 
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons={false}
                sx={{
                    minHeight: 0,
                    padding: '0px 24px',
                    '& .MuiTabs-indicator': {
                        backgroundColor: theme.palette.primary.main,
                    },
                }}
            >
                {tabs.length > 0 && tabs.map((tab,i) => (
                    <Tab 
                        key={i}
                        label={tab.label}
                        value={tab.index}
                        sx={{
                            letterSpacing: 0,
                            textTransform: 'none',
                            display: 'flex',
                            justifyContent: 'start',
                            alignContent: 'center',
                            gap: '2px',
                            lineHeight: 1,
                            fontSize: '14px',
                            fontFamily: 'Montserrat',
                            minHeight: 0,
                            padding: '12px 16px',
                            transition: 'all 0.3s ease-in-out',
                            '&.Mui-selected': {
                                color: theme.palette.primary.main,
                            },
                            '&:hover': {
                                color: theme.palette.primary.main,
                            },
                        }}
                    />
                ))}
            </Tabs>
            {/* <div className="w-full flex justify-start items-stretch gap-6 px-6">
                {items.map((item,i) => (
                    <button key={i} onClick={item.action} className={`px-6 py-3 text-[14px] rounded-tl-lg rounded-tr-lg ${selectedIndex === i ? 'bg-secondary border-b-2 border-primary' : 'bg-none border-none'}`}>
                        <p className={`text-nowrap ${selectedIndex === i ? 'text-primary font-semibold' : 'text-disable font-medium'}`}>{item.label}</p>
                    </button>
                ))}
            </div> */}
        </div>
    )
}